import { useState, useEffect, useTransition } from "react";

/**
 * A custom React hook that indicates whether the client is hydrated or not.
 * The hook will return false on SSR and on the client until the app has finished hydrating.
 * This is useful for rendering components only client-side without causing hydration mismatch warnings.
 *
 * @returns {boolean} The value indicating whether the client is hydrated.
 */
export default function useIsClientHydrated() {
    const [isClientHydrated, setIsClientHydrated] = useState(false);
    const [, startTransition] = useTransition();

    useEffect(() => {
        startTransition(() => {
            setIsClientHydrated(true);
        });
    }, []);

    return isClientHydrated;
}
